import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";

export const WarrantyTableDashboard = ({ dateRange }) => {

  const [body, setBody] = useState([]);
  useEffect(() => {
    init(dateRange);
  }, [dateRange]);

  async function init() {

    const result = await fuziElevatorsApi.fetchUpcomingWarranties();

    if (result) {
      setBody(result);
    } else {
      setBody([]);
    }
  } 

  const header = [
    {
      title: "Offer Name",
      prop: "offer_name_label",
      isFilterable: true,
      cell: (row) => (
        <Link to={`${ROUTES.WARRANTY.LIST}/${row.id}`} state={row}>
          {row.offer_name_label}
        </Link>
      ),
    },
    {
      title: "Days Left",
      prop: "days_left",
      isFilterable: true
    },

  ]; 
  return (

    <div>
      <Row className="g-0">
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 2,
                  options: [5, 10, 15, 20, 30],
                },
              }}
              sortProps={{
                initialState: {
                  sort: "leadname",
                  order: "desc",
                },
              }}
            >
              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              {body.length > 2 && <Pagination />}
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </div>
  );
};
